import React from 'react';
import "./ForGamersPart.scss";

import Freedom from 'assets/images/forGamers/freedom.png';
import WpShorter from 'assets/images/forGamers/wp-shorter.gif';
import Nfts from 'assets/images/forGamers/nfts.jpg';

export const ForGamersPart: React.FC = () => {
    const cards = [
        {
            id: 1,
            title: 'BECOME ONE OF US',
            text: <>Lurk in our digital cesspool. Get intel and exclusives from the streets of Miut 24 hours before anyone else. Join <a href="https://discord.com/invite/MgV32NTpAH" target="_blank" rel="noopener noreferrer">our Discord</a>!</>,
            image: Freedom,
            reversed: true,
        },
        {
            id: 2,
            title: 'GAIN THE EDGE',
            text: <>Snag an Eternal Whitelist Pass. Limited quantity. Early access to drops. In-game bonuses. Your ticket to the real loot. Find out how to get a pass in <a href="https://discord.com/invite/MgV32NTpAH" target="_blank" rel="noopener noreferrer">our Discord</a>.</>,
            image: WpShorter,
            reversed: false,
        },
        {
            id: 3,
            title: 'GET YOUR FIRST WEAPON',
            text: <>Nothing comes free in Miut. Grind at the factory — maybe you'll manage to steal a piece. Start at <a href="https://game.neuroborncats.com" target="_blank" rel="noopener noreferrer">game.neuroborncats.com</a></>,
            image: Nfts,
            reversed: true,
        }
    ]
    return (
        <div className="for-gamers">
            <div className="for-gamers-content">
                <div className="for-gamers-header">
                    <p className="for-gamers-title">
                        YOUR CURRENT MISSIONS
                    </p>
                    <p className="for-gamers-description">
                        <i>Gatia eats the feeble for breakfast. Hungry? Earn it. Want to live? Arm up.</i>
                    </p>
                </div>
                <div className="for-gamers-list">
                    {cards.map((card) => (
                        <div key={card.id} className={card.reversed ? 'for-gamers-card reversed' : 'for-gamers-card'}>
                            <img src={card.image} className="for-gamers-card-image" alt="image" />
                            <div className="for-gamers-card-content">
                                <p className="for-gamers-card-title">{card.title}</p>
                                <p className="for-gamers-card-text">{card.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
